import { WebStorageStateStore } from 'oidc-client-ts';
import { config } from '@shared/config';

export const oidcConfig = {
  authority: config.oidcAuthority,
  client_id: config.oidcClientId,
  redirect_uri: config.oidcRedirectUri,
  post_logout_redirect_uri: config.oidcPostLogoutRedirectUri,
  scope: `openid profile email urn:zitadel:iam:org:project:id:${config.oidcProjectId}:aud`,
  response_type: 'code' as const,
  automaticSilentRenew: true,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};
